module.exports = __webpack_public_path__ + "img/1569879530.518a60b4.jpg";